import UUID from 'uuidjs'

const UUIDPlugin = {}

UUIDPlugin.install = function (Vue) {
  Vue.prototype.$uuid = UUID
}

export default UUIDPlugin
